import { Injectable } from '@angular/core';

import { PrivacyModalFlow } from '../../../../pages/privacy/privacyActions.service';
import { ModalName } from '../../../components/ui/ui-modal-routeless/modal.routeless.service';
import { MetadataType } from '../../../models/privacy/Identity.model';
import { PrivacyValuesService } from '../../../values/privacy.values.service';
import { ModalSize } from '../../global/modal/Modal.model';
import { PrivacyService } from '../../process/privacy/privacy.service';
import { ModalAction } from './models/special.cases.model';
import { Steps } from '../../../components/ui/ui-steps/ui-steps.component';

@Injectable({
    providedIn: 'root'
})

export class PrivacyHelperService {

    private readonly enterMetadataStep = 1;
    private readonly validateMetadataStep = 2;

    constructor(
        private readonly privacyService: PrivacyService,
        private readonly privacyValuesService: PrivacyValuesService
    ) {}

    //#region deschiderea de modale onboarding
    //!! de mutat metodele in privacy.actions.service (se deschid modalele - finishOnBoardingDataValidations - si la validarea de metadate din exposure)
    /**
    * Metoda ce deschide onboardingul daca userul nu are identitate
    * @returns {ModalAction} obiectul modalei care va fi deschisa
    */
    public openOnBoardingFromBegining(): ModalAction {
        const containerOptions = {
            type: this.privacyValuesService.modals.onboarding,
            size: ModalSize.AUTO,
            buttonDismissable: false,
            backdropDismissable: false,
            exceptionClass: this.privacyValuesService.modals.onboarding
        };
        const contentOptions = {
            flow: PrivacyModalFlow.ONBOARDING
        };

        return {
            name: ModalName.onboardingStandardNameModal,
            containerOptions,
            contentOptions
        };
    }

    /**
     * Metoda ce afiseaza state-ul de loading din onboarding atunci cand userul a facut onboardingul dar inca nu am primit date de la lid
     * @returns {ModalAction} obiectul modalei care va fi deschisa
     */
    public openOnBoardingWaitingStatus(): ModalAction {
        const containerOptions = {
            type: this.privacyValuesService.modals.onboarding,
            size: ModalSize.XL,
            buttonDismissable: false,
            backdropDismissable: false,
            exceptionClass: this.privacyValuesService.modals.onboarding
        };

        return {
            name: ModalName.onboardingStandardDpyStatusModal,
            contentOptions: {},
            containerOptions
        };
    }

    /**
     * Metoda ce deschide modala de onboarding la pasul de configurare metadate
     * @param {IdentityModel} identitatea configurata pana in acest moment
     * @returns {ModalAction} obiectul modalei care va fi deschisa
     */
    public finishOnBoardingDataValidations(): ModalAction {
        const containerOptions = {
            type: this.privacyValuesService.modals.onboarding,
            size: ModalSize.AUTO,
            buttonDismissable: false,
            backdropDismissable: false,
            exceptionClass: this.privacyValuesService.modals.onboarding,
            flow: PrivacyModalFlow.ONBOARDING
        };
        const contentOptions = {
            flow: PrivacyModalFlow.ONBOARDING
        };
        const response = {
            name: ModalName.onboardingStandardEmailModal,
            containerOptions,
            contentOptions
        };

        this._decideModalInfo(response, contentOptions);

        return response;
    }

    /**
     * Metoda ce seteaza tipul modalei ce se va deschide si pasul din modala
     * este valabila aceasta verificare numai in onboarding (acolo sunt date numai de tipul EMAILS sau PHONES)
     * @param {response} final object to be returned
     * @param {contentOption} contentOption of the modal
     * @returns {nothing}
     */
    private _decideModalInfo(response, contentOptions): void {
        const metadataTypeNeededForOnboarding = this.privacyService.getNextMetatdataTypeForFinishingOnboarding();

        if (metadataTypeNeededForOnboarding === MetadataType.EMAILS) {
            response.name = ModalName.onboardingStandardEmailModal;
        } else if (metadataTypeNeededForOnboarding === MetadataType.PHONES) {
            if (this.privacyService.hasRequiredMetadataThatNeedsValidation()) {
                contentOptions['phone_type'] = this.privacyService.getRequiredMetadataSubtypeThatNeedsValidation();
                response.name = ModalName.onboardingStandardPhoneModal;
            }
            else {
                response.name = ModalName.onboardingStandardChoosePhoneModal;
            }
        }

//solutie temporara pana cand refactorizez si phone modal
        if (this.privacyService.hasRequiredMetadataThatNeedsValidation()) {
            contentOptions['activeStep'] = metadataTypeNeededForOnboarding === MetadataType.EMAILS ? Steps.ONE : this.validateMetadataStep;
        } else {
            contentOptions['activeStep'] = metadataTypeNeededForOnboarding === MetadataType.EMAILS ? Steps.ZERO :  this.enterMetadataStep;
        }
    }
    //#endregion

}
